import { useEffect, useState } from "react";
import { ThumbsUp, Send } from "lucide-react";

const TEXT = "ja tak 2";
const reduced = () => typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

// phases: 0 typing, 1 posted, 2 reply, 3 like, 4 messenger chip
export default function AuthDemo({ short = false }) {
  const [still] = useState(reduced);
  const [n, setN] = useState(still ? TEXT.length : 0);
  const [phase, setPhase] = useState(still ? 4 : 0);

  useEffect(() => {
    if (still) return;
    const ts = [];
    const run = () => {
      setN(0); setPhase(0);
      for (let i = 1; i <= TEXT.length; i++) ts.push(setTimeout(() => setN(i), 500 + i * 140));
      [[1, 1900], [2, 2900], [3, 3700], [4, 4500]].forEach(([p, t]) => ts.push(setTimeout(() => setPhase(p), t)));
      ts.push(setTimeout(run, 8000));
    };
    run();
    return () => ts.forEach(clearTimeout);
  }, [still]);

  return (
    <div className={`ad${short ? " short" : ""}`} data-testid="auth-demo" data-phase={phase} aria-hidden="true">
      {!short && (
        <div className="ad-post">
          <span className="ad-av shop">KB</span>
          <div>
            <b>Købmand Berg</b>
            <p>Søndagstilbud! Skriv "ja tak" for at reservere.</p>
            <span className="tag">Hel flæskesteg · 49,95 kr.</span>
          </div>
        </div>
      )}
      <div className="ad-row">
        <span className="ad-av">M</span>
        <div className="ad-bubble">
          <b>Mette Hansen</b>
          <span data-testid="auth-demo-typed">{TEXT.slice(0, n)}{phase === 0 && <i className="ad-caret" />}</span>
          {phase >= 3 && <span className="ad-like" data-testid="auth-demo-like"><ThumbsUp size={11} /> 1</span>}
        </div>
      </div>
      {phase >= 2 && (
        <div className="ad-row reply" data-testid="auth-demo-reply">
          <span className="ad-av shop">KB</span>
          <div className="ad-bubble">
            <b>Købmand Berg</b>
            <span>✅ Mette, du har 2 stk. reserveret! Din afhentningskode er sendt i Messenger.</span>
          </div>
        </div>
      )}
      {phase >= 4 && <span className="ad-chip" data-testid="auth-demo-chip"><Send size={12} /> Messenger-bekræftelse sendt</span>}
    </div>
  );
}
